// // // import axios from 'axios';

// // // const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api';

// // // const apiClient = axios.create({
// // //   baseURL: API_BASE_URL,
// // //   timeout: 30000,
// // //   headers: {
// // //     'Content-Type': 'application/json',
// // //   },
// // // });

// // // // Request interceptor
// // // apiClient.interceptors.request.use(
// // //   (config) => {
// // //     const token = localStorage.getItem('authToken');
// // //     if (token) {
// // //       config.headers.Authorization = `Bearer ${token}`;
// // //     }
// // //     return config;
// // //   },
// // //   (error) => Promise.reject(error)
// // // );

// // // // Response interceptor
// // // apiClient.interceptors.response.use(
// // //   (response) => response.data,
// // //   (error) => {
// // //     if (error.response?.status === 401) {
// // //       localStorage.removeItem('authToken');
// // //       window.location.href = '/login';
// // //     }
// // //     return Promise.reject(error.response?.data || error.message);
// // //   }
// // // );

// // // export default apiClient;
// // import axios from 'axios';

// // const apiClient = axios.create({
// //     baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
// //     headers: { 'Content-Type': 'application/json' },
// //     withCredentials: false,
// // });

// // // ── Request: attach token ─────────────────────────────────────────────
// // apiClient.interceptors.request.use(
// //     (config) => {
// //         const token = localStorage.getItem('authToken');
// //         if (token) config.headers.Authorization = `Bearer ${token}`;
// //         if (config.data instanceof FormData) delete config.headers['Content-Type'];
// //         return config;
// //     },
// //     (error) => Promise.reject(error)
// // );

// // // ── Response: handle 401 + silent refresh ─────────────────────────────
// // let isRefreshing = false;
// // let failedQueue  = [];

// // const processQueue = (error, token = null) => {
// //     failedQueue.forEach((p) => error ? p.reject(error) : p.resolve(token));
// //     failedQueue = [];
// // };

// // apiClient.interceptors.response.use(
// //     (response) => response,
// //     async (error) => {
// //         const original = error.config;

// //         if (error.response?.status === 401 && !original._retry) {
// //             if (isRefreshing) {
// //                 return new Promise((resolve, reject) => failedQueue.push({ resolve, reject }))
// //                     .then((token) => { original.headers.Authorization = `Bearer ${token}`; return apiClient(original); })
// //                     .catch((err) => Promise.reject(err));
// //             }

// //             original._retry = true;
// //             isRefreshing    = true;

// //             try {
// //                 const res      = await apiClient.post('/login/refresh-token');
// //                 const newToken = res.data?.data?.accessToken;
// //                 if (newToken) {
// //                     localStorage.setItem('authToken', newToken);
// //                     apiClient.defaults.headers.common.Authorization = `Bearer ${newToken}`;
// //                     processQueue(null, newToken);
// //                     original.headers.Authorization = `Bearer ${newToken}`;
// //                     return apiClient(original);
// //                 }
// //             } catch (refreshError) {
// //                 processQueue(refreshError, null);
// //                 localStorage.removeItem('authToken');
// //                 localStorage.removeItem('authUser');
// //                 window.location.href = '/login';
// //                 return Promise.reject(refreshError);
// //             } finally {
// //                 isRefreshing = false;
// //             }
// //         }

// //         return Promise.reject(error.response?.data || error);
// //     }
// // );

// // export default apiClient;
// // import axios from 'axios';

// // const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// // const apiClient = axios.create({
// //     baseURL: BASE_URL,
// //     headers: { 'Content-Type': 'application/json' },
// //     withCredentials: true,
// // });

// // const refreshClient = axios.create({
// //     baseURL: BASE_URL,
// //     headers: { 'Content-Type': 'application/json' },
// //     withCredentials: true,
// // });

// // const PUBLIC_ROUTES = [
// //     '/login',
// //     '/login/refresh-token',
// //     '/vendor/register',
// //     '/vendor',
// //     '/forgot-password',
// //     '/sports',
// // ];

// // const isPublicRoute = (url = '') => {
// //     return PUBLIC_ROUTES.some((route) => url.includes(route));
// // };

// // apiClient.interceptors.request.use(
// //     (config) => {
// //         const token = localStorage.getItem('authToken');

// //         if (token) {
// //             config.headers.Authorization = `Bearer ${token}`;
// //         }

// //         if (config.data instanceof FormData) {
// //             delete config.headers['Content-Type'];
// //         }

// //         return config;
// //     },
// //     (error) => Promise.reject(error)
// // );

// // let isRefreshing = false;
// // let failedQueue = [];

// // const processQueue = (error, token = null) => {
// //     failedQueue.forEach((promise) => {
// //         if (error) {
// //             promise.reject(error);
// //         } else {
// //             promise.resolve(token);
// //         }
// //     });
// //     failedQueue = [];
// // };

// // apiClient.interceptors.response.use(
// //     (response) => response,
// //     async (error) => {
// //         const original = error.config;

// //         if (!error.response) {
// //             return Promise.reject(error);
// //         }

// //         const status = error.response.status;
// //         const requestUrl = original?.url || '';

// //         if (
// //             status === 401 &&
// //             !original?._retry &&
// //             !isPublicRoute(requestUrl)
// //         ) {
// //             if (isRefreshing) {
// //                 return new Promise((resolve, reject) => {
// //                     failedQueue.push({ resolve, reject });
// //                 })
// //                     .then((token) => {
// //                         original.headers.Authorization = `Bearer ${token}`;
// //                         return apiClient(original);
// //                     })
// //                     .catch((err) => Promise.reject(err));
// //             }

// //             original._retry = true;
// //             isRefreshing = true;

// //             try {
// //                 const res = await refreshClient.post('/login/refresh-token');
// //                 const newToken = res?.data?.data?.accessToken;

// //                 if (!newToken) {
// //                     throw new Error('No access token returned from refresh-token');
// //                 }

// //                 localStorage.setItem('authToken', newToken);
// //                 apiClient.defaults.headers.common.Authorization = `Bearer ${newToken}`;
// //                 processQueue(null, newToken);

// //                 original.headers.Authorization = `Bearer ${newToken}`;
// //                 return apiClient(original);
// //             } catch (refreshError) {
// //                 processQueue(refreshError, null);
// //                 localStorage.removeItem('authToken');
// //                 localStorage.removeItem('authUser');
// //                 window.location.href = '/login';
// //                 return Promise.reject(refreshError?.response?.data || refreshError);
// //             } finally {
// //                 isRefreshing = false;
// //             }
// //         }

// //         return Promise.reject(error.response?.data || error);
// //     }
// // );

// // export default apiClient;
// // export { refreshClient };
// import axios from 'axios';

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const apiClient = axios.create({
//     baseURL: BASE_URL,
//     headers: { 'Content-Type': 'application/json' },
//     withCredentials: true,
// });

// const refreshClient = axios.create({
//     baseURL: BASE_URL,
//     headers: { 'Content-Type': 'application/json' },
//     withCredentials: true,
// });

// const isPublicRoute = (url = '') => {
//     const pathWithoutParams = url.split('?')[0].replace(/\/$/, '');
//     const path = pathWithoutParams.startsWith('/') ? pathWithoutParams : `/${pathWithoutParams}`;

//     const exactPublicRoutes = [
//         '/login/login',
//         '/login/admin/login',
//         '/login/vendor-referee/login',
//         '/login/refresh-token',
//         '/login/forgot-password',
//         '/login/reset-password',
//         '/login/register',
//         '/login/logout',
//         '/vendor/register',
//         '/vendors/register',
//         '/sports',
//         '/sports/all',
//     ];

//     return exactPublicRoutes.includes(path);
// };

// apiClient.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem('authToken');

//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }

//         if (config.data instanceof FormData) {
//             delete config.headers['Content-Type'];
//         }

//         return config;
//     },
//     (error) => Promise.reject(error)
// );

// let isRefreshing = false;
// let failedQueue = [];

// const processQueue = (error, token = null) => {
//     failedQueue.forEach((promise) => {
//         if (error) {
//             promise.reject(error);
//         } else {
//             promise.resolve(token);
//         }
//     });
//     failedQueue = [];
// };

// apiClient.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const original = error.config;

//         if (!error.response) {
//             return Promise.reject(error);
//         }

//         const status = error.response.status;
//         const requestUrl = original?.url || '';

//         if (
//             status === 401 &&
//             !original?._retry &&
//             !isPublicRoute(requestUrl)
//         ) {
//             if (isRefreshing) {
//                 return new Promise((resolve, reject) => {
//                     failedQueue.push({ resolve, reject });
//                 })
//                     .then((token) => {
//                         original.headers.Authorization = `Bearer ${token}`;
//                         return apiClient(original);
//                     })
//                     .catch((err) => Promise.reject(err));
//             }

//             original._retry = true;
//             isRefreshing = true;

//             try {
//                 const res = await refreshClient.post('/login/refresh-token');
//                 const newToken = res?.data?.data?.accessToken;

//                 if (!newToken) {
//                     throw new Error('No access token returned from refresh-token');
//                 }

//                 localStorage.setItem('authToken', newToken);
//                 apiClient.defaults.headers.common.Authorization = `Bearer ${newToken}`;
//                 processQueue(null, newToken);

//                 original.headers.Authorization = `Bearer ${newToken}`;
//                 return apiClient(original);
//             } catch (refreshError) {
//                 processQueue(refreshError, null);
//                 localStorage.removeItem('authToken');
//                 localStorage.removeItem('authUser');
//                 window.location.href = '/login';
//                 return Promise.reject(refreshError?.response?.data || refreshError);
//             } finally {
//                 isRefreshing = false;
//             }
//         }

//         return Promise.reject(error.response?.data || error);
//     }
// );

// export default apiClient;
// export { refreshClient };
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

const refreshClient = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

const isPublicRoute = (url = '') => {
    const pathWithoutParams = url.split('?')[0].replace(/\/$/, '');
    const path = pathWithoutParams.startsWith('/') ? pathWithoutParams : `/${pathWithoutParams}`;

    const exactPublicRoutes = [
        '/login/login',
        '/login/admin/login',
        '/login/vendor-referee/login',
        '/login/refresh-token',
        '/login/forgot-password',
        '/login/reset-password',
        '/login/register',
        '/login/logout',
        '/vendor/register',
        '/vendors/register',
        '/sports',
        '/sports/all',
    ];

    return exactPublicRoutes.includes(path);
};

// NEW — routes where a 401 response does NOT mean "your session/token is
// invalid" — it means a normal, expected business-logic rejection (e.g.
// "current password is incorrect"). These stay authenticated (the request
// interceptor below still attaches the Bearer token as usual), but a 401
// from them must NOT trigger the silent refresh-token flow or the
// force-logout-and-redirect-to-/login fallback. Add any other endpoint here
// that can legitimately return 401 for reasons other than an expired
// session (the config-level `skipAuthRefresh: true` flag below works too,
// e.g. `apiClient.patch(url, body, { skipAuthRefresh: true })`).
const AUTH_ACTION_ROUTES_SKIP_REFRESH = [
    '/login/me/change-password',
];

const shouldSkipAuthRefresh = (config) => {
    if (config?.skipAuthRefresh) return true;

    const url = config?.url || '';
    const pathWithoutParams = url.split('?')[0].replace(/\/$/, '');
    const path = pathWithoutParams.startsWith('/') ? pathWithoutParams : `/${pathWithoutParams}`;

    return AUTH_ACTION_ROUTES_SKIP_REFRESH.includes(path);
};

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        return config;
    },
    (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((promise) => {
        if (error) {
            promise.reject(error);
        } else {
            promise.resolve(token);
        }
    });
    failedQueue = [];
};

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const original = error.config;

        if (!error.response) {
            return Promise.reject(error);
        }

        const status = error.response.status;
        const requestUrl = original?.url || '';

        if (
            status === 401 &&
            !original?._retry &&
            !isPublicRoute(requestUrl) &&
            !shouldSkipAuthRefresh(original)
        ) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        original.headers.Authorization = `Bearer ${token}`;
                        return apiClient(original);
                    })
                    .catch((err) => Promise.reject(err));
            }

            original._retry = true;
            isRefreshing = true;

            try {
                const res = await refreshClient.post('/login/refresh-token');
                const newToken = res?.data?.data?.accessToken;

                if (!newToken) {
                    throw new Error('No access token returned from refresh-token');
                }

                localStorage.setItem('authToken', newToken);
                apiClient.defaults.headers.common.Authorization = `Bearer ${newToken}`;
                processQueue(null, newToken);

                original.headers.Authorization = `Bearer ${newToken}`;
                return apiClient(original);
            } catch (refreshError) {
                processQueue(refreshError, null);
                localStorage.removeItem('authToken');
                localStorage.removeItem('authUser');
                window.location.href = '/login';
                // return Promise.reject(refreshError?.response?.data || refreshError);
                const refreshPayload = { ...(refreshError?.response?.data || {}) };
                refreshPayload.status = refreshError?.response?.status;
                return Promise.reject(refreshError?.response ? refreshPayload : refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        // NEW — for routes in AUTH_ACTION_ROUTES_SKIP_REFRESH (or any call
        // made with `skipAuthRefresh: true`), a 401 falls straight through
        // to here instead of triggering the block above: no silent token
        // refresh, no force-logout, no redirect. The caller's own .catch
        // just receives the backend's error body (e.g.
        // { success: false, message: 'Current password is incorrect' })
        // exactly like any other 4xx business error.
        // return Promise.reject(error.response?.data || error);
        const payload = { ...(error.response?.data || {}) };
        payload.status = error.response?.status;

        return Promise.reject(error.response ? payload : error);
    }
);

export default apiClient;
export { refreshClient };